import React from 'react';
import Card from '../../Shared/Cards/BlogCard/Card';
import { cards1 } from './data';
import './Styles/Cards.scss';

const Cards=()=>{
    return(
        <div className="blog-cards">
            {cards1.map((d,i) =>{
                return(
                    <Card 
                    key={i} {...d}
                    />
                )
            })}
        </div>
    )
};
export default Cards ;